import * as React from "react";
import { SVGProps } from "react";
export const CalendarDotFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.25 18.333C3.764 18.333 3.35067 18.163 3.01 17.823C2.67 17.4823 2.5 17.069 2.5 16.583V5.16699C2.5 4.68099 2.67 4.26766 3.01 3.92699C3.35067 3.58699 3.764 3.41699 4.25 3.41699H4.917V2.52099C4.917 2.28499 5.00033 2.08366 5.167 1.91699C5.33367 1.75033 5.542 1.66699 5.792 1.66699C6.028 1.66699 6.23267 1.75366 6.406 1.92699C6.58 2.10099 6.667 2.30599 6.667 2.54199V3.41699H13.333V2.52099C13.333 2.28499 13.4163 2.08366 13.583 1.91699C13.7497 1.75033 13.958 1.66699 14.208 1.66699C14.444 1.66699 14.649 1.75366 14.823 1.92699C14.9963 2.10099 15.083 2.30599 15.083 2.54199V3.41699H15.75C16.236 3.41699 16.6493 3.58699 16.99 3.92699C17.33 4.26766 17.5 4.68099 17.5 5.16699V16.583C17.5 17.069 17.33 17.4823 16.99 17.823C16.6493 18.163 16.236 18.333 15.75 18.333H4.25ZM4.25 16.583H15.75V8.37499H4.25V16.583Z"
            fill="currentColor"
        />
        <path
            d="M10.5 14.323C10.9167 14.733 11.4237 14.938 12.021 14.938C12.6043 14.938 13.1007 14.733 13.51 14.323C13.92 13.913 14.125 13.4163 14.125 12.833C14.125 12.2363 13.92 11.7293 13.51 11.312C13.1007 10.896 12.6043 10.688 12.021 10.688C11.4237 10.688 10.9167 10.896 10.5 11.312C10.0833 11.7293 9.875 12.2363 9.875 12.833C9.875 13.4163 10.0833 13.913 10.5 14.323Z"
            fill="currentColor"
        />
    </svg>
);
CalendarDotFillIcon.displayName = "CalendarDotFillIcon";
